import React, { useEffect } from "react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Nav } from "@/components/mera/Nav";
import { Hero } from "@/components/mera/Hero";
import { Foundry } from "@/components/mera/Foundry";
import { Ecosystem } from "@/components/mera/Ecosystem";
import { Matr } from "@/components/mera/Matr";
import { Stats } from "@/components/mera/Stats";
import { Founders } from "@/components/mera/Founders";
import { Press } from "@/components/mera/Press";
import { Waitlist } from "@/components/mera/Waitlist";
import { Footer } from "@/components/mera/Footer";

function App() {
  // Reveal-on-scroll observer for any element marked with `.reveal`
  useEffect(() => {
    const els = document.querySelectorAll(".reveal");
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-visible");
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    els.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  return (
    <div className="App paper-grain relative" data-testid="app-root">
      <Nav />
      <main className="relative z-[2]">
        <Hero />
        <Foundry />
        <Ecosystem />
        <Matr />
        <Stats />
        <Founders />
        <Press />
        <Waitlist />
      </main>
      <Footer />
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
